import React from 'react';
import { Home, MapPin } from 'lucide-react';

const MobileService = () => {
  return (
    <section id="mobile" className="relative bg-[#F4EFE7] pt-10 pb-24 lg:pb-32">
      <div className="vertical-divider hidden lg:block"></div>

      <div className="max-w-[1100px] mx-auto px-8 lg:px-12 relative">
        <div className="bg-[#FBF7F0] border border-[#1E1B18]/8 rounded-sm p-10 lg:p-14 overflow-hidden relative">
          {/* Soft decorative circle — desktop only to avoid mobile horizontal overflow */}
          <div
            aria-hidden="true"
            className="hidden xl:block absolute -right-20 -top-20 w-72 h-72 rounded-full opacity-60 pointer-events-none"
            style={{ background: 'radial-gradient(closest-side, #E5DDF0, transparent 70%)' }}
          />

          <div className="relative grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">
            <div className="lg:col-span-3">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-full bg-[#E5DDF0] flex items-center justify-center">
                  <Home size={16} className="text-[#7B6BA6]" strokeWidth={1.6} />
                </div>
                <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium">
                  ALSO AVAILABLE AT YOUR HOME
                </p>
              </div>

              <h3 className="font-serif text-4xl lg:text-5xl leading-[1.05] text-[#1E1B18] mb-5">
                The same session,<br />without the drive.
              </h3>

              <p className="text-[15px] text-[#1E1B18]/70 leading-relaxed max-w-lg">
                Prefer to unwind in your own space? I bring the table, linens, and calm to you.
                Mobile sessions are offered at the <span className="text-[#1E1B18] font-medium">same price as in-studio</span> — no surprises, same quality of care.
              </p>
            </div>

            <div className="lg:col-span-2">
              <div className="bg-[#F4EFE7] border border-[#1E1B18]/10 rounded-sm p-6">
                <div className="flex items-center gap-2 mb-4">
                  <MapPin size={14} className="text-[#7B6BA6]" strokeWidth={1.7} />
                  <p className="text-[11px] tracking-[0.25em] text-[#1E1B18]/60 font-medium">TRAVEL</p>
                </div>
                <ul className="space-y-3 text-[14px] text-[#1E1B18]/80">
                  <li className="flex items-start justify-between gap-3">
                    <span>Within 15 km of the spa</span>
                    <span className="font-medium text-[#1E1B18] whitespace-nowrap">Complimentary</span>
                  </li>
                  <li className="flex items-start justify-between gap-3 pt-3 border-t border-[#1E1B18]/10">
                    <span>Beyond 15 km</span>
                    <span className="font-medium text-[#1E1B18] whitespace-nowrap">$1 / km</span>
                  </li>
                </ul>
                <p className="mt-4 text-[11px] text-[#1E1B18]/50 leading-relaxed">
                  Travel fees are added to your total and shown before you confirm. Just mention your address when you book.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileService;
